<template>
  <div>
    <v-flex>
      <v-layout wrap justify-space-between>
        <v-flex xs5 mb-3 mr-md-0 mr-3>
          <h3 class="font-weight-medium display-30 mb-3">
            משרות שהסרתי ({{ JobBasketSize }})
          </h3>
        </v-flex>
      </v-layout>
    </v-flex>

    <Spinner v-if="showComponent" />

    <v-form v-model="formBasketModel" class="px-2">
      <v-list
        v-for="(item, i) in items"
        :key="i"
        class="pt-0 pb-6 jobList_vacancy"
        :class="`checkbox${item.Code}`"
      >
        <v-layout v-if="i === 9" mb-4 text-center>
          <v-flex class="inner_banner">
            <client-only>
              <GptAd
                class="resultsBanner_jobs"
                :ad-unit="dfpToShow.dfpID"
                :is-responsive="true"
                :size="dfpToShow.dfpSize"
              />
            </client-only>
          </v-flex>
        </v-layout>
        <v-layout
          class="job-select-box"
          :class="{ selected: jobBasketModel[i] }"
        >
          <v-flex :class="'xs12'">
            <JobItem
              :job-details="item"
              class="job-item"
              :is-single-job="false"
              :display-cv-btn="true"
              :showRank="true"
              :recomended-job="item.JobInfo.IsRecommender"
            />
          </v-flex>
        </v-layout>
      </v-list>
    </v-form>

    <v-layout v-show="emptyMsg" column justify-center text-center>
      <v-flex>
        <h3 class="display-24 mb-2">לא נמצאו משרות שהסרת</h3>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import jobBasketBaseVue from './mixins/jobBasketBase.vue';
import { API_URL } from '@/lib/api.js';

export default {
  mixins: [jobBasketBaseVue],

  data() {
    return {
      API_URL: `${API_URL}/?jbstatus=3`,
      status: 3,
    };
  },
  computed: {
    JobBasketSize() {
      return this.NoJobBasket.length;
    },
  },
};
</script>
